var React = require('react');

function Burger (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0.888832 14.2217H30.2222V16.8883H0.888832V14.2217Z","fill":"#141414","key":0}),React.createElement("path",{"d":"M1.77772 4.44434H30.2222V7.111H1.77772V4.44434Z","fill":"#141414","key":1}),React.createElement("path",{"d":"M12.4444 24H30.2222V26.6667H12.4444V24Z","fill":"#141414","key":2})]);
}

Burger.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = Burger;

Burger.default = Burger;
